import React from 'react'

import { Box, Typography } from '@material-ui/core'
import { NonDismissibleDialog } from '@scoir/modals'
import PropTypes from 'prop-types'

import GoogleOAuthButton from './OAuthButton/GoogleOAuthButton'
import OutlookOAuthButton from './OAuthButton/OutlookOAuthButton'

const { Body, Footer } = NonDismissibleDialog
const { CloseButton } = Footer

class CalendarSourceModal extends React.Component {
  render() {
    return (
      <NonDismissibleDialog
        open={this.props.isOpen}
        onClose={this.props.onClose}
        headerText="Select a Calendar Source"
      >
        <Body>
          <Typography>
            Please select your Calendar provider. Once connected, you can select specific Calendars to sync. Be aware,
            Pop-Up Blockers may interrupt the next step.
          </Typography>
          <Box
            display="flex"
            justifyContent="space-evenly"
            alignItems="center"
            flexDirection={{ xs: 'column', sm: 'row' }}
            mt={2}
          >
            <Box mb={{ xs: 1, sm: 0 }}>
              <GoogleOAuthButton onOAuthStart={this.props.onClose} />
            </Box>
            <OutlookOAuthButton onOAuthStart={this.props.onClose} />
          </Box>
        </Body>
        <Footer>
          <CloseButton>Cancel</CloseButton>
        </Footer>
      </NonDismissibleDialog>
    )
  }
}

CalendarSourceModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
}

export default CalendarSourceModal
